import { render, staticRenderFns } from "./TravoltaNotFound.vue?vue&type=template&id=a2b22cf6&"
import script from "./TravoltaNotFound.vue?vue&type=script&lang=js&"
export * from "./TravoltaNotFound.vue?vue&type=script&lang=js&"
import style0 from "./TravoltaNotFound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
